import * as React from 'react';
import { OnlyForFairPlayersWrapper } from '../OnlyForFairPlayersWrapper';

export const OnlyForFairPlayersSuccess = () => {
  return (
    <OnlyForFairPlayersWrapper>
      Запрос на&nbsp;участие в&nbsp;программе «Работаю честно» отправлен.
      <br />
      Ожидайте ответа в&nbsp;течение суток.
    </OnlyForFairPlayersWrapper>
  );
};
